import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InvitationEditorModule } from '../../../../../components/invitation-editor/invitation-editor.module';
import { InvitationTemplateModalComponent } from './invitation-template-modal.component';

@NgModule({
  declarations: [InvitationTemplateModalComponent],
  exports: [InvitationTemplateModalComponent],
  imports: [CommonModule, InvitationEditorModule],
})
export class InvitationTemplateModalModule {}
